import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { useCountry } from '../contexts/CountryContext';
import grabLogo from '../images/Grab Logo.png';
import ShopeeLogo from '../images/Shopee.png';
import Foodpanda from '../images/Foodpanda.png';
import Mcdonalds from '../images/Mcdonalds.png';
import gofoodLogo from '../images/gofoodLogo18.png';
import Maximlogo from '../images/Maxim.png';
import config from '../config'; // Adjust the import path as necessary

const dataContext = createContext();

export const useData = () => {
  const context = useContext(dataContext);
  if (!context) {
    throw new Error('useData must be used within a DataProvider');
  }
  return context;
};

  const logoMap = {
    'grabLogo.png': <img src={grabLogo} alt="Grab Logo" style={{ width: '30%' }} />,
    'Shopee.png': <img src={ShopeeLogo} alt="Shopee Logo" style={{ width: '31%' }} />,
    'Mcdonalds': <img src={Mcdonalds} alt="Mcdonalds Logo" style={{ width: '11%' }} />,
    'Foodpanda': <img src={Foodpanda} alt="Foodpanda Logo" style={{ width: '30%' }} />,
    'gofood': <img src={gofoodLogo} alt="Gofood Logo" style={{ width: '23%' }} />,
    'Maximlogo': <img src={Maximlogo} alt="Maxim Logo" style={{ width: '23%' }} />,
  };

export const DataProvider = ({ children }) => {
  const { selectedCountry, filters,countryName,globalFilter,projectno } = useCountry();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [sampleBrands, setSampleBrands] = useState([]);

  // This function will automatically re-run when selectedCountry or filters.city changes
  const fetchData = useCallback(async () => {
    if (!countryName) {
      setSampleBrands([]);
      return;
    }

    try {
      setLoading(true);
      const params = new URLSearchParams();
      params.append('country', countryName);
      params.append('project', projectno);
      if (projectno== '2') {
      params.append('cats', filters.cat);}
      if (filters && filters.city?.length>0 && filters.city && filters.city !== 'All') {
        params.append('city', filters.city);
      } else {
        params.append('city', 'Total');
      }


      if (filters && filters?.wave && filters.wave !== '') {
        params.append('wave', filters.wave || '');
      }
        else
            params.append('wave', 'Aug\'25');
      if (filters && filters.brands?.length>0) {
          filters.brands.forEach(brand => {
    params.append('brands', brand);
  });
      } else {
        params.append('brands', '');
      }
    params.append('category', globalFilter || 'Brand Funnel');
      const response = await fetch(`${config.API_BASE_URL}/api/funnel-data?${params}`);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      setSampleBrands(data.data || []);
      setError(null);
    } catch (err) {
      setError(err.message);
      console.error('Error fetching funnel data:', err);
    } finally {
      setLoading(false);
    }
  }, [selectedCountry, filters,globalFilter,projectno]);

  
  // Automatically fetch data when selectedCountry or filters.city changes
  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const value = {
    loading,
    error,
    sampleBrands,
    fetchData, // provide fetchData if you want manual refresh
    setSampleBrands,logoMap
  };

  return (
    <dataContext.Provider value={value}>
      {children}
    </dataContext.Provider>
  );
};

export default DataProvider;